/* Star Faced — minimal front-end controller */
(function () {
  var SF = {
    openMenu: function () { document.documentElement.classList.add('sf-menu-open'); },
    closeMenu: function () { document.documentElement.classList.remove('sf-menu-open'); },
    openCart: function () { window.location.href = window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart' : '/cart'; },
    closeCart: function () {},
    closeCase: function () {},
    toggle: function (el) {
      var menu = el.parentNode.querySelector('.ed-sortmenu, .ed-filtermenu');
      if (menu) menu.classList.toggle('sf-show');
    }
  };
  window.SF = SF;
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') SF.closeMenu(); });
  // Live cart count in the header badge
  function refreshCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-sf-cart-count]').forEach(function (n) {
        n.textContent = c.item_count;
        n.style.display = c.item_count > 0 ? 'flex' : 'none';
      });
    }).catch(function(){});
  }
  document.addEventListener('DOMContentLoaded', refreshCount);
})();
